import { Button, Flex, Text, useDisclosure, VStack } from '@chakra-ui/react'
import { createCn } from 'shared-utils/utils'
import { overrideText } from 'ui/lib/overrides'
import { useOverridesContext } from 'ui/lib/overrides/hooks'
import { useProductContext } from '../hooks/useProductContext'
import MarketplaceProductsItem from './MarketplaceProductsItem'

const cn = createCn('product-marketplace-products')

export interface MarketplaceProductsOverrides {
  marketplaceProductsShowMore?: string
  marketplaceProductsShowLess?: string
  marketplaceProductsNoVendorsFound?: string
}

const MarketplaceProducts = () => {
  const { marketplaceProducts } = useProductContext()
  const { isOpen, onToggle } = useDisclosure()
  const overrides = useOverridesContext<keyof MarketplaceProductsOverrides>()

  if (!marketplaceProducts?.length) {
    return (
      <Flex
        my={2}
        p={6}
        w="full"
        color="gray.600"
        fontSize="xl"
        h="full"
        justifyContent="center"
        alignItems="center">
        <Text>
          {overrideText(
            'Inga återförsäljare hittades.',
            overrides?.marketplaceProductsNoVendorsFound
          )}
        </Text>
      </Flex>
    )
  }

  return (
    <VStack my={2} w="full" className={cn()}>
      {marketplaceProducts
        .slice(0, isOpen ? marketplaceProducts.length : 3)
        .map((marketplaceProduct) => (
          <MarketplaceProductsItem
            {...{ marketplaceProduct }}
            key={marketplaceProduct.articleNumber}
          />
        ))}
      {marketplaceProducts.length > 3 && (
        <Button rounded="sm" w="full" onClick={onToggle} mt={2}>
          {isOpen
            ? overrideText('Visa mindre', overrides?.marketplaceProductsShowLess)
            : overrideText('Visa mer', overrides?.marketplaceProductsShowMore)}
        </Button>
      )}
    </VStack>
  )
}

export default MarketplaceProducts
